// デザインボード：画面デザイン（.pen / OpenPencil）と業務フローボード（Excalidraw）。doc/design/pm-design-board-screens.html
export default {
  "design.tab": "デザイン",
  "design.page.entry": "デザイン（白板 / .pen）",
  "design.page.title": "デザイン",
  "design.page.titleOf": "{name} · デザイン",
  "design.page.subtitle":
    "画面截图・付箋・矢印で流れを整理し、.pen 原稿と一緒に版管理・レビューします",
  "design.page.new": "新規作成",
  "design.page.filteredByTask": "タスク「{name}」のデザインのみ表示中",
  "design.page.showAll": "すべて表示",
  "design.empty": "デザインはまだありません",
  "design.untitled": "無題の業務フロー",
  "design.back": "一覧に戻る",
  "design.more": "その他",
  "design.retry": "再試行",
  "design.saved": "v{rev} として保存しました",
  "design.col.title": "タイトル",
  "design.col.format": "種類",
  "design.col.task": "紐付けタスク",
  "design.col.revision": "版",
  "design.col.updated": "更新",
  "design.format.excalidraw": "業務フロー",
  "design.format.pen": "画面デザイン",
  "design.deleteConfirm": "「{title}」を削除しますか？",
  "design.deleteHint": "すべての版とレビューコメントが一覧から消えます。",
  "design.edit.title": "デザインを編集",
  "design.edit.taskHint": "空にするとプロジェクト全体のデザインになります。",
  "design.field.title": "タイトル",
  "design.field.titlePlaceholder": "空欄なら「無題の白板」またはファイル名",
  "design.field.task": "紐付けタスク",
  "design.field.note": "変更メモ",
  "design.create.title": "デザインを作成",
  "design.create.ok": "作成",
  "design.create.mode": "作成方法",
  "design.create.blank": "空のボード",
  "design.create.file": ".excalidraw ファイルから取り込む",
  "design.file.drop": "ファイルをドロップ、またはクリックして選択",
  "design.file.hint": ".excalidraw · {mb}MB まで（画像込み）",
  "design.file.need": "ファイルを選んでください",
  "design.source.title": "Git 由来（任意）",
  "design.source.hint":
    "Git で管理しているファイルの場所を記録します。認証情報（トークン入り URL）は入力しないでください。自動で pull / push はしません。",
  "design.source.repo": "リポジトリ",
  "design.source.ref": "ブランチ / ref",
  "design.source.path": "リポジトリ内のパス",
  "design.source.commitSha": "コミット SHA",
  "design.upload.menu": "新しい版をアップロード",
  "design.upload.title": "新しい版（v{rev}）をアップロード",
  "design.upload.ok": "取り込む",
  "design.export.file": "ファイルを書き出す",
  "design.export.manifest": "メタ情報を書き出す（.design.json）",
  "design.status.dirty": "未保存",
  "design.status.saving": "保存中…",
  "design.status.saved": "保存済み",
  "design.status.error": "保存失敗",
  "design.leave.title": "保存していない変更があります",
  "design.leave.content": "このまま移動すると、未保存の変更は失われます。",
  "design.leave.ok": "破棄して移動",
  "design.conflict.title": "他の人が先に保存しました",
  "design.conflict.content":
    "あなたの変更はまだ画面に残っています。最新を読み込むと、あなたの変更は破棄されます。必要なら先に別デザインとして保存するか、下書きをダウンロードしてください。",
  "design.conflict.reload": "最新を読み込む（変更を破棄）",
  "design.conflict.keep": "画面に戻る",
  "design.conflict.saveAsCopy": "自分の変更を別デザインとして保存",
  "design.conflict.copyTitle": "{title}（競合時のコピー）",
  "design.conflict.download": "下書きをダウンロード（.excalidraw）",
  "design.history.banner": "v{rev} を表示中（読み取り専用、最新は v{latest}）",
  "design.history.latest": "最新に戻る",
  "design.history.restore": "この版から復元",
  "design.restore.note": "v{rev} から復元",
  "design.pen.limitTitle": "ブラウザ内での .pen の表示・編集は未対応です",
  "design.pen.limitBody":
    "原文はそのまま（1 バイトも変えずに）保存・書き出しできます。OpenPencil 原生画布の組み込みと無損な書き戻しは検証が済んでいないため提供していません。下の手順で編集してください。",
  "design.pen.file": "ファイル名",
  "design.pen.size": "サイズ",
  "design.pen.download": ".pen をダウンロード",
  "design.pen.step1": "「.pen をダウンロード」で原文を取得する",
  "design.pen.step2": "OpenPencil など .pen 対応ツールで開いて編集・保存する",
  "design.pen.step3":
    "「ファイルから新しい版を取り込む」でアップロードする（他の人が先に版を進めていた場合は取り込めません）",
  "design.comment.title": "レビュー",
  "design.comment.scopeRev": "v{rev}",
  "design.comment.scopeAll": "すべての版",
  "design.comment.none": "コメントはまだありません",
  "design.comment.loadFailed": "コメントを読み込めませんでした",
  "design.comment.placeholder": "v{rev} へのコメント",
  "design.comment.post": "コメントする",
  "design.comment.empty": "コメントを入力してください",
  "design.comment.resolved": "解決済み",
  "design.comment.resolvedBy": "{name} が解決",
  "design.comment.deleteConfirm": "このコメントを削除しますか？",
  "design.task.openList": "デザインボードを開く",
  "design.error.load": "デザインを読み込めませんでした",
  "design.error.notFound":
    "デザインが見つかりません（削除されたか、閲覧権限がありません）",
  "design.error.parse":
    "保存されている内容を白板として読めません。上書きを防ぐため編集できません。",
  "design.error.save": "保存できませんでした",
  "design.error.network": "サーバに接続できません。変更は画面に残っています。",
  "design.error.size":
    "データが大きすぎます（画像込みで 10MB まで）。画像を縮小するか枚数を減らしてください",
  "design.error.elements": "要素が多すぎます（5000 個まで）",
  "design.error.embeddable":
    "埋め込み（Web 埋め込み）要素は保存できません。削除してから保存してください",
  "design.error.image-missing":
    "画像データが欠落しています。画像を貼り直してから保存してください",
  "design.error.image-type":
    "この画像形式は保存できません（PNG / JPEG / GIF / WebP のみ）",
  "design.error.image-size": "画像が大きすぎます（1 枚 5MB まで）",
  "design.error.type": ".excalidraw または .pen ファイルを選んでください",
  "design.error.format": "このデザインと違う種類のファイルです",
  "design.close": "閉じる",
  "design.frame.status.draft": "下書き",
  "design.frame.status.review": "レビュー待ち",
  "design.frame.status.changes": "要修正",
  "design.frame.status.approved": "承認",
  "design.frame.list": "画面一覧",
  "design.frame.panel": "タスク・レビュー",
  "design.frame.search": "画面を検索",
  "design.frame.collapse": "画面一覧を閉じる",
  "design.frame.expand": "画面一覧を開く",
  "design.frame.none": "画面（最上位のフレーム）がありません",
  "design.frame.reviewStatus": "レビュー状態",
  "design.frame.tasks": "紐付けタスク",
  "design.frame.unlink": "紐付けを外す",
  "design.frame.linkTask": "＋ タスクを紐付け",
  "design.frame.notInLatest":
    "この画面は最新版にありません（レビュー状態・タスクは最新版の画面に付けます）",
  "design.frame.removed": "最新版で削除",
  "design.pen.historyBanner":
    "v{rev} を表示中（最新は v{latest}）。レビュー状態・タスクは最新の値です",
  "design.pen.missingFonts":
    "一部のフォントを読み込めず、代替フォントで表示しています：{fonts}",
  "design.pen.viewerError": "この .pen を表示できませんでした",
  "design.pen.loading": "OpenPencil で読み込み中…",
  "design.pen.selectHint":
    "画面をクリックすると、レビュー状態・タスク・コメントを付けられます。.pen の編集は Pencil で行い、「新しい版をアップロード」で取り込みます",
  "design.pen.uploaded": "v{rev} をアップロードしました",
  "design.board.frames": "画面 {n}",
  "design.board.filter.all": "すべて",
  "design.board.newPen": "画面デザイン（.pen）",
  "design.board.newPenHint":
    ".pen をアップロードして OpenPencil で表示・レビュー",
  "design.board.newFlow": "業務フローボード",
  "design.board.newFlowHint":
    "画面・付箋・矢印で業務の流れを描く（Excalidraw）",
  "design.board.empty":
    "デザインボードはまだありません。「新規作成」から .pen をアップロードするか、業務フローボードを作成してください",
  "design.create.penTitle": "画面デザイン（.pen）をアップロード",
  "design.create.boardTitle": "業務フローボードを作成",
  "design.create.penHint":
    "Pencil で作成した .pen をそのまま保存し、OpenPencil で表示します（ブラウザでの .pen 編集はできません）",
  "design.file.hintPen": ".pen · {mb}MB まで",
  "design.flow.add": "画面を追加",
  "design.flow.addTitle": "フローボードに画面を追加",
  "design.flow.addOk": "{n} 件を追加",
  "design.flow.pickNeed": "追加する画面を選んでください",
  "design.flow.pickAll": "すべて選択",
  "design.flow.renderFailed": "画面の画像を書き出せませんでした。",
  "design.flow.noPen":
    "このプロジェクトには画面デザイン（.pen）がまだありません",
  "design.flow.renderHint":
    "画像はブラウザ内の OpenPencil で書き出します。レビュー状態・タスクは画面デザイン側と共通です",
  "design.flow.added": "画面を {n} 件追加しました（保存すると確定します）",
  "design.flow.refreshed":
    "v{rev} の画像に更新しました（保存すると確定します）",
  "design.flow.source": "参照元：{design} · v{rev}",
  "design.flow.outdated": "画面デザインに新しい版 v{rev} があります",
  "design.flow.refresh": "v{rev} に更新",
  "design.flow.frameGone":
    "参照元の画面が見つかりません（削除された可能性があります）",
  "design.flow.shared": "画面デザインと共通",
  "design.flow.openDesign": "画面デザインで開く",
  "design.task.empty": "このタスクに紐付いた画面・フローボードはありません",
};
